export const OTP_CORRECT = "1402"; // Change this to your desired OTP

export const VIDEO_URL = `${process.env.PUBLIC_URL}/assets/videos/video1.mp4`; // Change this to your desired video URL (local or remote)
